import { breakpoint } from '../style/variables.js';

const ERROR_RECOVERY_SCRIPT_ID = 'swag-error-recovery';
const ERROR_RECOVERY_TOAST_ID = 'swag-error-recovery-toast';

export const errorRecovery = ({
  enableErrorRecovery,
  errorRecoveryResponseTimeout = 10000,
  maxErrorResourceCount = 3,
} = {}) => {
  if (!enableErrorRecovery) return '';

  return /* html */ `
    <script type="text/javascript" id="${ERROR_RECOVERY_SCRIPT_ID}">
      (function() {
        const MAX_ERROR_RESOURCE_COUNT = ${maxErrorResourceCount};
        const ERROR_RECOVERY_RESPONSE_TIMEOUT_MSEC = ${errorRecoveryResponseTimeout};
        const ERROR_RECOVERY_TOAST_ID = '${ERROR_RECOVERY_TOAST_ID}';
        let errorResourceCount = 0;
        let isReloading = false;
        const url = new URL(window.location.href);

        window.addEventListener(
          'error',
          e => {
            const { message, target } = e;
            if (target.tagName) {
              const tag = target.tagName.toLowerCase();
              let targetUrl = {};
              try{
                targetUrl = new URL(target.src);
              } catch(_) {}

              if (
                tag === 'script' &&
                targetUrl.hostname === location.hostname &&
                /\\.js$/.test(targetUrl.href)
              ) {
                console.log('Script resource error: ', target.src);
                errorResourceCount += 1;
                if (errorResourceCount >= MAX_ERROR_RESOURCE_COUNT && !isReloading) {
                  console.log('Show toast');
                  isReloading = true;
                  showErrorRecoveryToast();
                }
              }
            }
          },
          true
        );

        function reloadPage() {
          url.searchParams.set('clear', 1);
          history.replaceState(null, '', url.href);
          location.reload(true);
        }

        function createErrorRecoveryToast() {
          const width = window.innerWidth;
          let toastStyleCssText = 'position: fixed; z-index: 999; max-width: 100%; animation: fadeIn 0.3s ease-in-out;';
          
          if (width <= ${breakpoint.mobile}) {
            toastStyleCssText += 'width: calc(100% - 24px); bottom: 20px; left: 50%; transform: translateX(-50%); display: flex; justify-content: center;';
          } else if (${breakpoint.mobile} < width && width <= ${breakpoint.tablet}) {
            toastStyleCssText += 'width: 528px; bottom: 20px; left: 50%; transform: translateX(-50%); display: flex; justify-content: center;';
          } else {
            toastStyleCssText += 'width: 528px; bottom: 20px; left: 50%; transform: translateX(-50%); display: flex; justify-content: center;';
          }

          const wording = window.__ERROR_RECOVERY_WORDING__ || 'No internet connection';

          const toast = document.createElement('div');
          toast.id = '${ERROR_RECOVERY_TOAST_ID}';
          toast.style.cssText = toastStyleCssText;
          
          const wrapper = document.createElement('div');
          wrapper.style.cssText = 'width: 100%; max-width: 528px; min-height: 48px; max-height: 164px; border-radius: 8px; background-color: white; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); overflow: hidden; display: flex; flex-direction: column;';
          
          const notificationContent = document.createElement('div');
          notificationContent.style.cssText = 'display: flex; padding: 12px 16px; position: relative;';
          
          const iconWrapper = document.createElement('div');
          iconWrapper.style.cssText = 'display: flex; align-items: flex-start; margin-right: 12px; padding-top: 2px;';
          
          const infoIcon = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          infoIcon.setAttributeNS(null, 'width', '18');
          infoIcon.setAttributeNS(null, 'height', '18');
          infoIcon.setAttributeNS(null, 'fill', 'none');
          infoIcon.innerHTML = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0 C4.030 0 0 4.030 0 9 C0 13.970 4.030 18 9 18 C13.970 18 18 13.970 18 9 C18 4.030 13.970 0 9 0 Z" fill="#CF0404"/><path d="M5.677 5.760L11.907 12.240" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.907 5.760L5.677 12.240" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          iconWrapper.appendChild(infoIcon);
          
          const textContent = document.createElement('div');
          textContent.style.cssText = 'flex: 1; display: flex; justify-content: end; flex-direction: column; overflow: hidden;';
          
          const title = document.createElement('div');
          title.style.cssText = 'font-size: 14px; font-weight: 600; line-height: 1.5; color: #000; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; margin-bottom: 4px;';
          title.textContent = wording;
          
          textContent.appendChild(title);
          
          notificationContent.appendChild(iconWrapper);
          notificationContent.appendChild(textContent);
          
          const buttonGroup = document.createElement('div');
          buttonGroup.style.cssText = 'display: flex; justify-content: flex-end; padding: 0 16px 12px; gap: 8px; min-height: 38px;';
          
          const primaryButton = document.createElement('button');
          primaryButton.style.cssText = 'border: none; border-radius: 4px; padding: 6px 12px; font-size: 14px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; background-color: #CF0404; padding: 2px 22px; color: white; font-size: 12px;';
          primaryButton.textContent = 'Retry';
          primaryButton.addEventListener('click', reloadPage);
          
          const dismissButton = document.createElement('button');
          dismissButton.style.cssText = 'border: 1px solid #e0e0e0; border-radius: 4px; padding: 2px 22px; font-size: 12px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; background-color: white; color: #666;';
          dismissButton.textContent = 'Cancel';
          dismissButton.addEventListener('click', () => {
            const toast = document.getElementById(ERROR_RECOVERY_TOAST_ID);
            if (toast) {
              toast.style.animation = 'fadeOut 0.3s ease-in-out forwards';
              setTimeout(() => {
                toast.style.display = 'none';
                toast.style.animation = '';
              }, 300);
            }
          });
          
          buttonGroup.appendChild(primaryButton);
          buttonGroup.appendChild(dismissButton);
          
          wrapper.appendChild(notificationContent);
          wrapper.appendChild(buttonGroup);
          
          toast.appendChild(wrapper);
          
          document.body.appendChild(toast);

          const style = document.createElement('style');
          style.textContent = '@keyframes fadeIn { from { opacity: 0; transform: translate(-50%, 20px); } to { opacity: 1; transform: translate(-50%, 0); } }' +
            '@keyframes fadeOut { from { opacity: 1; transform: translate(-50%, 0); } to { opacity: 0; transform: translate(-50%, 20px); } }';
          document.head.appendChild(style);
        }

        function showErrorRecoveryToast() {
          const toast = document.getElementById('${ERROR_RECOVERY_TOAST_ID}');
          if (toast) {
            toast.style.animation = '';
            toast.offsetHeight;
            toast.style.animation = 'fadeIn 0.3s ease-in-out';
            toast.style.display = 'flex';
            return;
          }

          if (document.body) {
            createErrorRecoveryToast();
          } else {
            // this script is injected inside the head tag
            // when errors happen, the document.body might not exist
            // use MutationObserver to wait for the body element shows up
            const observer = new MutationObserver(function() {
              if (document.body) {
                createErrorRecoveryToast();
                observer.disconnect();
              }
            });
            observer.observe(document.documentElement, {childList: true});
          }
        }

        // make sure the first client js should clear this timeout
        window.__INDEX_JS_RESPONSE_TIMEOUT__ = setTimeout(() => {
          console.log('Show toast because timeout')
          showErrorRecoveryToast();
        }, ERROR_RECOVERY_RESPONSE_TIMEOUT_MSEC)

        window.__showErrorRecoveryToast__ = showErrorRecoveryToast;
      })()
    </script>
    `;
};

export const clearErrorRecovery = () => {
  if (window.__INDEX_JS_RESPONSE_TIMEOUT__)
    clearTimeout(window.__INDEX_JS_RESPONSE_TIMEOUT__);

  const toast = document.getElementById(ERROR_RECOVERY_TOAST_ID);
  if (toast) toast.style.display = 'none';
};
